import { useCaptchaHook } from '@aacn.eu/use-friendly-captcha'

export const useCaptcha = (options = {}) => {
  const captcha = useCaptchaHook({
    siteKey: 'FCMMC0792QV3716I',
    endpoint: 'GLOBAL1',
    language: 'de',
    startMode: 'none',
    showAttribution: false,
    ...options,
  })

  return {
    ...captcha,
    CaptchaWidget: captcha.CaptchaWidget.bind(null, undefined),
  }
}
